<template>
<div class="sd-bg--gray">
  <div class="pt-3 row">
    <!-- TODO: Update Paths >> Check vue documentation -->
    <div class="col-sm-8"><img src="@/assets/img/logo_icon.svg" alt="" srcset=""></div>
    <div class="col-sm-4 text-right"><profileIcon></profileIcon></div>
  </div>
  <!-- Search bar start -->
  <form style='display: none;' class="pt-4 sd-form">
    <div class="form-group">
      <div class="input-group">
      <div class="input-group-prepend">
          <span class="input-group-text sd-form__inputprepend sd-bg--white">
          <img src="@/assets/img/search_icon.svg" width="13px" class="img-fluid" alt="">
          </span>
      </div>
      <input type="text"
            class="form-control sd-form__input sd-bg--white"
            id="dashSearch"
            placeholder="Search">
      </div>
    </div>
  </form>
 <!-- Search Bar End -->
  <h2 class="h6 pt-3 font-weight-bold">All Projects</h2>
  <div
      class="sd-card  mt-4 p-2"
      v-for="project in projects" :key="project.project_id"
      :class="{'sd-card--stack':project.stacked}"
      @click="triggerCard(project)"
      >

      <div
          class="row no-gutters"
          @mouseover="emitData(project)"
          >
          <div class="col-lg-3">
              <img :src="project.image" class="img-fluid sd-project-image" alt="">
          </div>
          <div class="col-lg-6 pl-2 pt-2">
              <span>
                  <h2 class="h6 m-0 sd-card__heading">{{ project.name }}</h2>
                  <small class="text-muted sd-card__subheading">
                    {{ project.location }}
                  </small>
              </span>
              <br>
              <!--
              <button class="btn btn-danger btn-sm sd-card__btn mb-0 mt-4">
                  {{ project.subsections.length }} Sections
                  <img src="@/assets/img/project_dropdown.svg"
                        class="img-fluid ml-1" width="13px" alt="">
              </button>
              -->
          </div>
          <div class="col-lg-3 pt-2 py-2">
              <button class="btn btn-primary btn-sm sd-card__btn"
                v-on:mouseover.stop
                @click="OpenVideoMode(project.project_id, project.subsections[0].subsection_id)">
                  Open Project
                  <img src="@/assets/img/open_project.svg"
                        class="img-fluid ml-1" width="13px" alt="">
              </button>
              <div class="text-right pr-2 mt-4 mb-0 sd-card__progress">
                  <p>{{ project.percentage }} %</p>
                  <span class="dot" :class="decideColor( project.status )"></span>
                  <h5 class="m-0 pl-1">{{ project.status }}</h5>
              </div>
          </div>
      </div>
      <div :class="{'sd-card-phase-view':project.stacked}">
      <div v-for="subsection in project.subsections" :key="subsection.subsection_id">
        <hr class="sd-linebreak">
        <div class="row no-gutters" >
            <div class="col-lg-7">
                <h2 class="sd-card__heading  mb-2">
                    <span class="dot" :class="decideColor(subsection.status)"></span>
                    <a
                      class="ml-2"
                      @click="emitSubsectionId(subsection.subsection_id)"
                      href="#"
                    >
                      {{ subsection.name }}
                    </a>
                </h2>
                <p class="sd-card__subheading ml-4 mb-4 sd-fw--bold">
                  {{ subsection.description }}
                </p>
                <p class="sd-card__subheading text-muted ml-4 mb-0">
                    {{ subsection.status }}
                </p>
            </div>
            <div class="col-lg-5">
                <p class="sd-card__subheading text-primary">
                  <button class="btn btn-light btn-sm sd-card__btn text-primary"
                    @click="OpenVideoMode(project.project_id, subsection.subsection_id)">
                    Open Project at {{ subsection.name }}
                    <!-- <img src="@/assets/img/open_project_orange.svg"  width="13px" alt=""> -->
                  </button>
                </p>
            </div>
        </div>
      </div>
      </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import  profileIcon from '@/components/profileIcon.vue';
export default {
  data() {
    return {
    };
  },
   mounted() {
    this.$root.$on('openVideoModeFromPopup', (id) => {
      Array.from(this.projects).forEach((project) => {
        if ( project.project_id == id) {          
          this.OpenVideoMode(project.project_id, project.subsections[0].subsection_id);         
        }
      });      
    });
  },  
  components: {
    profileIcon
  },
  computed: {
    ...mapState([
      'projects',
    ]),
    ...mapGetters([
      'loggedIn',
    ]),
  },
  methods: {
    emitSubsectionId(id) {
      this.$emit('changeSubsectionId', id);
    },
    emitData(project) {
      if (project.stacked === true) {
        this.$root.$emit('hoverProjectCard', project.project_id);
      } else {
        this.$root.$emit('zoomToPhase', project.project_id);
        // Send Nothing. Note that triggerCard function will draw the polyline.
        // We don't have to redraw map.
      }
    },
    decideColor(string) {
      switch (string) {
        case 'Yet to begin':
          return 'dot-gray';
        case 'In progress':
          return 'dot-yellow';
        case 'Completed':
          return 'dot-green';
        default:
          return 'dot-green';
      }
    },
    triggerCard(project) {
      // eslint-disable-next-line
      // project.stacked = !project.stacked;
      if (project.stacked) {
        this.$root.$emit('destroyPolyline', project.project_id);
      } else {
        this.$root.$emit('drawPolyline', project.project_id);
      }
    },
    OpenVideoMode(projectId, subsectionId) {
      this.$router.push({
        name: 'VideoMode',
        query: {
          pid: projectId,
          sid: subsectionId || 1,
        },
      });
    },
  },

};
</script>

<style lang="scss">

// TODO: Organize Projects CSS classes into separate file
@import '@/assets/sass/_variables.scss';

.sd-linebreak {
  border-color: $gray-light;
}

.sd-fw--bold {
  font-weight: 600;
}

.sd-card-phase {
  display: none;
}

.sd-card-phase-view {
  display: none;
  transition: all 3s;
}

.sd-card {
  background: #fff;
  border-radius: 0.2rem;
  .sd-project-image {
    border-radius: 0.3rem;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }
  .sd-card__btn {
    font-size: 0.6rem;
    border-radius: 1rem;
  }
  .sd-card__heading {
    font-size: 0.95rem;
  }
  .sd-card__subheading {
    font-size: 0.75rem;
  }
  .sd-card__progress {
    p {
      font-size: 0.8rem;
      font-weight: 600;
      margin-bottom: 0;
    }
    h5 {
      font-size: 0.8rem;
      color: $gray;
      font-weight: 400;
      display: inline;
    }
  }
}

.dot {
  height: 14px;
  width: 14px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: -2px;
}

.dot-yellow {
  background-color: $yellow;
}

.dot-green {
  background-color: $green;
}

.dot-gray {
  background-color: $gray;
  opacity: 0.6;
}

.sd-card--stack {
  box-shadow:
    /* The top layer shadow */ 0 -1px 1px rgba(0, 0, 0, 0.1),
    /* The second layer */ 0 -10px 0 -5px $white,
    /* The second layer shadow */ 0 -10px 1px -4px rgba(0, 0, 0, 0.1),
    /* The third layer */ 0 -20px 0 -10px $white,
    /* The third layer shadow */ 0 -20px 1px -9px rgba(0, 0, 0, 0.1);
  /* Padding for demo purposes */
  padding: 30px;
}
</style>
